import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDocPreview } from 'hooks/useDocPreview'
import { PDF_MIME_TYPE } from 'constants/docUploadConstant'
import PDFView from 'components/PDFView'
import { usePDFLoading } from 'hooks/usePDFLoading'

const SidesUploadPreview = ({ base64Data, mimeType }) => {
    const previewProps = usePDFLoading({ base64Data, mimeType })
    const { setIsLoading, setLoadingProgress } = useDocPreview()
    const { src } = previewProps

    useEffect(() => {
        if (mimeType !== PDF_MIME_TYPE && base64Data) {
            setLoadingProgress(100)

            setTimeout(() => {
                setIsLoading(false)
            }, 500)
        }
    }, [base64Data, mimeType, setIsLoading, setLoadingProgress])

    if (mimeType === PDF_MIME_TYPE) {
        return <PDFView {...previewProps} />
    }

    return <img src={src} alt="Upload preview" width="100%" style={{ height: 191, width: 307 }} />
}

SidesUploadPreview.propTypes = {
    base64Data: PropTypes.string,
    mimeType: PropTypes.string,
    setLoadingProgress: PropTypes.func,
    setIsLoading: PropTypes.func
}

export default SidesUploadPreview
